import { Injectable } from '@angular/core';
import { UserManager } from 'oidc-client';
import { BehaviorSubject } from 'rxjs';
import { from } from 'rxjs';
import { config } from '@environments/environment';
import { ISessionService, ISession } from '@core/core.interfaces';
import { Endpoints } from '@config/endpoints';
import { Constants } from '@config/constants';
import { Identity } from '@core/model/Identity';
import { DataService } from '@core/services/DataService';

@Injectable()
export class SessionService implements ISessionService {

  public isLoggedIn = new BehaviorSubject(false);
  public identity = new BehaviorSubject(null);
  public manager: UserManager;

  constructor(private dataService: DataService) {
    this.manager = new UserManager({
      authority: config.identityBaseUrl,
      client_id: 'js.sf.admin',
      redirect_uri: `${config.publicUrl}/callback.html`,
      response_type: 'id_token token',
      scope: 'openid profile sf-admin-api',
      post_logout_redirect_uri: `${config.publicUrl}/signout-callback-oidc`,
    });
  }

  async loadProfile(): Promise<Identity> {
    const response = await this.dataService.request<Identity>(Endpoints.Profile);
    this.identity.next(response);
    return response;
  }

  startSession() {
    const session = this.getSession();
    if (session) {
      this.isLoggedIn.next(true);
    }
  }

  async hasSession() {
    const session = await this.getSession();
    return !!session && !!session.access_token;
  }

  async getSession() {
    const session = await this.manager.getUser();
    return session;
  }

  setSession(session: ISession) {
    if (session) {
      window.localStorage.setItem(Constants.accessTokenAlias, session.accessToken);
      this.isLoggedIn.next(true);
    }
  }

  observeSession() {
    return from(this.getSession());
  }

  resetSession() {
    window.localStorage.removeItem(Constants.accessTokenAlias);
    this.isLoggedIn.next(false);
    this.requireLogin();
  }

  requireLogin() {
    this.manager.signinRedirect();
  }

  loginCallback() {
    return this.manager.signinRedirectCallback();
  }

  logout() {
    window.localStorage.removeItem(Constants.accessTokenAlias);
    this.manager.signoutRedirect();
  }

}
